import React from 'react';
import { Box } from '@common-fe/common-fe';

import ClaimsActivityReportCard from './ReportCard/ClaimsActivityReportCard';
import ContributionInvoiceCard from './ReportCard/ContributionInvoiceCard';
import DelinquentClaimsReportCard from './ReportCard/DelinquentClaimsReportCard/DelinquentClaimsReportCard';
import EmployeeDemographicCard from './ReportCard/EmployeeDemographicCard';
import HealthPlanEnrollmentCard from './ReportCard/HealthPlanEnrollmentCard';
import PlanOmnibusBalanceReportCard from './ReportCard/PlanOmnibusBalanceReportCard';
import PrefundInvoiceCard from './ReportCard/PrefundInvoiceCard';
import ReplenishmentInvoiceCard from './ReportCard/ReplenishmentInvoiceCard';
import { usePlanOmnibusBalanceVisible } from './ReportDetails/PlanOmnibusBalanceReport/hooks';
import {
  CardStatusCard,
  CIPStatusCard,
  ForfeitureCard,
  ParticipantActivityReportCard,
  PayrollReportCard,
  ReportFavoriteCards,
  UndeliverableMailReportCard,
} from './ReportCard';
import ReportSection from './ReportSection';

const NewReportsList = () => {
  const hasPlanOmnibusBalanceReportFeatureFlag = usePlanOmnibusBalanceVisible();
  return (
    <Box direction="column" margin={{ top: 'spacing24' }}>
      <ReportFavoriteCards />
      <Box height="1px" background="border1" margin={{ vertical: 'spacing16' }} />

      <ReportSection title="Invoice Reconciliation (3)">
        <PrefundInvoiceCard />
        <ReplenishmentInvoiceCard />
        <ContributionInvoiceCard />
      </ReportSection>

      <Box height="1px" background="border1" margin={{ vertical: 'spacing16' }} />
      <ReportSection title="Enrollments (2)">
        <HealthPlanEnrollmentCard />

        <ParticipantActivityReportCard />
      </ReportSection>

      <Box height="1px" background="border1" margin={{ vertical: 'spacing16' }} />

      <ReportSection title={`Claims & Funding (${hasPlanOmnibusBalanceReportFeatureFlag ? 5 : 4})`}>
        <ClaimsActivityReportCard />

        <PayrollReportCard />
        <ForfeitureCard />
        {hasPlanOmnibusBalanceReportFeatureFlag && <PlanOmnibusBalanceReportCard />}
        <DelinquentClaimsReportCard />
      </ReportSection>

      <Box height="1px" background="border1" margin={{ vertical: 'spacing16' }} />

      <ReportSection title="Employee Data (4)">
        <CIPStatusCard />

        <EmployeeDemographicCard />
        <CardStatusCard />
        <UndeliverableMailReportCard />
      </ReportSection>
    </Box>
  );
};

export default NewReportsList;
